import React from 'react';
import './Upcoming.css';
import arrow from '../../img/arrow_upcoming.png'

const Upcoming = (props) => {
    const state = {
        upcoming_item: [ 
            {
                title: `Beginner Track`,
                desc: `Data Science Kick-start, Machine & Deep Learning, Natural Language Processing`,
                month: `June`,
                day: `28`,
            },
            {
                title: `Pro Track`,
                desc: `Machine & Deep Learning, Natural Language Processing, MLOps & Data Engineering`,
                month: `June`,
                day: `29`,
            },
            {
                title: `Bootcamp`,
                desc: `6 hours of practical content`,
                month: `June`,
                day: `30`,
            },
      ],
    };

    const renderUpcoming_item = (item, i) => {
        return (
            <div className='upcoming_block' key={`upcoming_block-${i}`}>
                <div className='upcoming_circle'>
                    <h5 className='upcoming_title'>{item.title}</h5>
                    <p className='upcoming_desc'>{item.desc}</p>
                </div>
                <div className='upcoming_data'>
                    <p className='upcoming_month'>{item.month}</p>
                    <p className='upcoming_day'>{item.day}</p>
                </div>
            </div>
        );
    };

    return (
        <div className="upcoming" id='upcoming'>
            <div className="container">
                <h3>Three event days:</h3>
                <div className='upcoming_blocks'>
                    {state.upcoming_item.map((item, i) => renderUpcoming_item(item, i))}
                </div>
                <div className='upcoming_arrow_block'>
                    <img src={arrow} alt="" />
                </div>
            </div>
        </div>
    );
};

export default Upcoming;